import {
  geGPSApiV1,
  geRXApiV1,
  geVideoApiV1,
  getCUDBClientApiV1,
  getStoreAdminApiV1,
  getApiV1 as v1Api,
  getFirstAdminApiV1,
  getReactApiV1,
  getBDSApiV1,
  getTwilioApiV1,
  getWorkflowApiV1
} from "../api";
import { getMessagingApiV1 as v1MessageApi } from "../api";
import { parseApiResponse, parseApiResponseJSON } from "../apiError";
import URls from "../../../constants/urls";

export const fetchRequestToken = async (auth0UserId: any) => {
  const response = await v1Api().post(
    "/",
    JSON.stringify({ auth0UserId: auth0UserId })
  );
  return parseApiResponse(response);
};

export const getPosts = async () => {
  const response = await v1Api().get(`/${URls.GET_LIST}`);
  return parseApiResponse(response);
};

export const loginUser = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/login", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const authenticate = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/authenticate", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const registerUser = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  // const register = {email, password, phoneNumber, beamId: '1', termsandcondition: true};
  return v1Api()
    .postJson("/register", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const verifyNewIds = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/verifyNewIds", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const requestResetPassword = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  // const register = {email, password, phoneNumber, beamId: '1', termsandcondition: true};
  return v1Api()
    .postJson("/addAuth", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const resetPassword = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  // const register = {email, password, phoneNumber, beamId: '1', termsandcondition: true};
  return v1Api()
    .postJson("/modifyAuth", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const modifyIds = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  // const register = {email, password, phoneNumber, beamId: '1', termsandcondition: true};
  return v1Api()
    .postJson("/modifyIds", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUserInfo = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/searchInUser", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUserAccount = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/getUserAccount", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const updateUserInfo = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/updateUser", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUsersList = async (payload: { data: any }) => {
  return v1Api()
    .postJson(`/searchUser`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const geDecryptPayload = async (payload: { data: any }) => {
  return getReactApiV1()
    .postJson(`/decryptPayloadTopic`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const uploadMedia = async (payload: any) => {
  return v1MessageApi()
    .postWithoutHeaders("/createMedium", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const searchMedia = async (payload: any) => {
  return v1MessageApi()
    .postJson("/searchInMedium", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getRXData = async (id: string) => {
  return geRXApiV1()
    .get("page/rx2?deviceId=" + id)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getVideoSnapshot = async (id: any) => {
  let headers = { APIKey: process.env.REACT_APP_VIDEO_API_KEY };
  return (
    geVideoApiV1()
      .getWithHeaders(
        `/SmartWitness/RESTCommandWebService/ExecuteServerCommand/Snapshots/GetURLs?RecorderID=${id}&CameraChannel=*`,
        headers
      )
      // return geVideoApiV1().getWithHeaders(`SmartWitness/RESTCommandWebService/ExecuteServerCommand/Devices/All`, headers)
      .then((response) => parseApiResponseJSON(response))
      .catch((error) => error.response.data.message)
  );
};

export const getMapPlaces = async (payload: JSON) => {
  return v1MessageApi()
    .postJson("/get/placesByBounds", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getMapPlacesFilter = async (payload: JSON) => {
  return v1MessageApi()
    .postJson("/get/places", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getLocationProfile = async (payload: JSON) => {
  return getCUDBClientApiV1()
    .postJson(`/searchInUser`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getVisit = async (visitId) => {
  return getStoreAdminApiV1()
    .get(`/visit/${visitId}`)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getStaff = async (search) => {
  return getStoreAdminApiV1()
    .get(`/staff/search/${search}`)
    .then(async (response) => {
      // console.log('respose here ', await response.json());
      // parseApiResponse(response)
      return response.json();
    })
    .catch((error) => error.response.data.message);
};

export const uploadCSV = async (payload: any) => {
  return getFirstAdminApiV1()
    .postWithoutHeaders("/api/v1/page-editor/createItemsUsingCSV", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};


export const getUsersAggregateList = async (payload: { data: any }) => {
  return getBDSApiV1()
    .postJson(`/aggregateBds`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getDecryptedPayload = async (payload: JSON) => {
  return getReactApiV1()
    .postJson(`/decryptPayloadTopic`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getGPSHistoricalData = async (payload: any) => {
  return geGPSApiV1()
    .postJson("/getRange", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const acceptTwilioReservation = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/twilioReservationAccepted`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const rejectTwilioReservation = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/twilioReservationRejected`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const completeTwilioReservation = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/twilioTaskCompleted`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getTwilioUserStatus = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/getTwilioUserStatus`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const updateTwilioUserStatus = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/updateTwilioUserStatus`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const saveTwilioRecording = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/saveTwilioRecording`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const holdTwilioCall = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/holdCall`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const addTwilioParticipant = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/addParticipant`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const saveOutgoingRecording = async (payload: { data: any }) => {
  return getTwilioApiV1()
    .postJson(`/${process.env.REACT_APP_ECO_SYSTEM}/wc-plus/wc-plus/service/wc-plus/recordOutgoingCall`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const invokeWorkflow = async (payload) => {
  return getWorkflowApiV1()
    .postJson("/invokeWorkflow", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};